export default {
  'cs-modal': require('./Modal/Modal.vue').default,
  'cs-input': require('./Input/Input.vue').default,
  'cs-switcher': require('./Switcher/Switcher.vue').default,
  'cs-spoiler': require('./Spoiler/Spoiler.vue').default,
  'cs-preloader-overlay': require('./PreloaderOverlay/PreloaderOverlay.vue').default,
  'cs-icon': require('./Icon/Icon.vue').default,
  'cs-icon-overlay': require('./Icon/IconOverlay.vue').default,
  'cs-off-canvas': require('./OffCanvas/OffCanvas.vue').default,
  'cs-button': require('./Button/Button.vue').default,
  'cs-scrollbar-vertical': require('./Scrollbar/ScrollbarVertical').default,
  'cs-dialog': require('./Dialog/Dialog').default,
  'cs-spinner': require('./Spinner/Spinner').default,
  'cs-input-validation': require('./Input/InputValidation').default,

  'base-icon': require('atoms/base/BaseIcon').default,
  'reusable-dialog': require('molecules/reusable/Dialog').default,
};
